import { FC } from 'react';

import VSpacing from 'bloko/blocks/vSpacing';

import { LetterGroupType, Letters } from 'src/models/searchCatalogList';
import { SearchTypeGenitive } from 'src/types/search/common';

import LetterLink from 'src/pages/SearchCatalogList/components/LetterLinks/LetterLink';

import styles from './letters.less';

interface LettersProps {
    catalogType: SearchTypeGenitive;
    letters: Letters;
}

const LetterLinks: FC<LettersProps> = ({ catalogType, letters }) => {
    return (
        <div className={styles.lettersContainer}>
            <div className={styles.letters}>
                <div className={styles.lettersGroup}>
                    {[...letters[LetterGroupType.RUS], ...letters[LetterGroupType.ETC]].map((letter) => (
                        <LetterLink key={letter.alias} catalogType={catalogType} letter={letter} />
                    ))}
                </div>
                <VSpacing base={4} />
                <div className={styles.lettersGroup}>
                    {letters[LetterGroupType.ENG].map((letter) => (
                        <LetterLink key={letter.alias} catalogType={catalogType} letter={letter} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LetterLinks;
